export default "__VITE_ASSET__OkeARpUJ__"